var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuoteLeftRound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112 256C106.002 256 100.23 256.857 94.486 257.766L96 256V192C96 156.75 124.75 128 160 128H168C181.25 128 192 117.25 192 104V56C192 42.75 181.25 32 168 32H160C71.625 32 0 103.625 0 192V368C0 429.855 50.145 480 112 480S224 429.855 224 368S173.855 256 112 256ZM400 256C394.002 256 388.23 256.857 382.486 257.766L384 256V192C384 156.75 412.75 128 448 128H456C469.25 128 480 117.25 480 104V56C480 42.75 469.25 32 456 32H448C359.625 32 288 103.625 288 192V368C288 429.855 338.145 480 400 480S512 429.855 512 368S461.855 256 400 256Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteLeftRound);
export default __webpack_public_path__ + "static/media/quote-left-round.c673954c1a3949fb674f5d2f14ab572e.svg";
export { ForwardRef as ReactComponent };